/**
 *
 * @param value - Decimal value to convert to percentage
 * @returns Percentage value
 *
 * @example
 * decimalValueToPercentage(0.5) // returns 50%
 * decimalValueToPercentage(0.75) // returns 75%
 * decimalValueToPercentage(1) // returns 100
 * decimalValueToPercentage(1.0254) // returns 102.54%
 * decimalValueToPercentage(0.2019) // returns 20.19%
 */
export const decimalValueToPercentage = (value: number): number => Math.round(value * 10_000) / 100;
